
    <!--
 * 横版-全局弹窗
 * @LastEditTime: Mon Jan 06 2025 17:26:49 GMT+0800 (China Standard Time)
 -->
 <template>
  <div id="u_c_3AAA17"  :class="[`normal`,`u_c_3AAA17`]" ><div id="u_c_YLOM18"  v-show="compData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup`,`u_c_YLOM18`]" @click="u_c_YLOM18_event_F8M123($event)"><div id="u_c_EZ8J19"  :class="[`normal popup-content-small`,`u_c_EZ8J19`]" @click="u_c_EZ8J19_event_2MZ224($event)"><div id="u_c_DDUR20"  :class="[`normal popup-title popup-title-color`,`u_c_DDUR20`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_B11P22"  :class="[`normal`,`u_c_B11P22`]" ><div id="u_c_DCJ823"  :class="[`normal select-item `,`u_c_DCJ823`]" ><select id="u_c_9I0S24"  v-model="pageData.serverItem" :class="[`normal select-item-select `,`u_c_9I0S24`]" ><option id="u_c_YB6125" disabled="disabled" :value="defaultServerItem" :class="[`normal`,`u_c_YB6125`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_5WSH27"  :label="langData.yourServer" :class="[`normal`,`u_c_5WSH27`]" ><option id="u_c_DI5W28"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_DI5W28`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_DTZ430"  :label="langData.allServer" :class="[`normal`,`u_c_DTZ430`]" ><option id="u_c_BL6L31"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_BL6L31`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_0BRZ33"  :class="[`normal select-item`,`u_c_0BRZ33`]" ><select id="u_c_6MFN34"  v-model="pageData.roleIndex" :class="[`normal select-item-select `,`u_c_6MFN34`]" ><option id="u_c_X5WC35"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_X5WC35`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_DKO437" href="javascript:;" :class="[`normal sure`,`u_c_DKO437`]" @click="u_c_DKO437_event_QSVC19($event)">{{`${ langData.bindBtn }`}}</a><div id="u_c_784339"  v-html="langData.canNoReBind" v-show="!pageData.canReBind" :class="[`normal txt-size tips-color`,`u_c_784339`]" ></div><a id="u_c_4AAC40" href="javascript:;" :class="[`normal popup-close`,`u_c_4AAC40`]" @click="u_c_4AAC40_event_DMX517($event)"></a></div></div><div id="u_c_B7PH41"  v-show="compData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup`,`u_c_B7PH41`]" @click="u_c_B7PH41_event_F8M123($event)"><div id="u_c_37AZ42"  :class="[`normal popup-content-big`,`u_c_37AZ42`]" @click="u_c_37AZ42_event_2MZ224($event)"><div id="u_c_YV9L43"  :class="[`normal popup-title popup-title-color`,`u_c_YV9L43`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_AJEN45"  :class="[`normal border-color`,`u_c_AJEN45`]" ><table id="u_c_FFLM46"  :class="[`normal`,`u_c_FFLM46`]" ><thead id="u_c_7SYQ47"  :class="[`normal`,`u_c_7SYQ47`]" ><td id="u_c_DR2P48"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_DR2P48`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_4DR950"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_4DR950`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_3MAG52"  :class="[`normal`,`u_c_3MAG52`]" ><tr id="u_c_V45S53"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :class="[`normal border-color tr `,`u_c_V45S53`]" ><td id="u_c_6VDD54"  :class="[`normal td border-color txt-size txt-color`,`u_c_6VDD54`]" >{{`${ packItem.award_time }`}}</td><td id="u_c_5EJF56"  :class="[`normal td border-color txt-size txt-color`,`u_c_5EJF56`]" ><span id="u_c_EGHL57"  v-html="packItem.award_name || giftInfo[packItem.award_block] && giftInfo[packItem.award_block][+packItem.send_id - 1] && giftInfo[packItem.award_block][+packItem.send_id - 1].name || ''" :class="[`normal`,`u_c_EGHL57`]" ></span><span id="u_c_0P5L58"  v-html="`${ langData.giftCode }：${ packItem.award_code }`" v-show="packItem.send_type == 'sendSerial'" :class="[`normal`,`u_c_0P5L58`]" ></span><a id="u_c_7LGZ59" href="javascript:;" v-show="packItem['send_type'] == 'sendCoupon'" :class="[`normal popup-title-color txt-size`,`u_c_7LGZ59`]" @click="u_c_7LGZ59_event_1JVM17($event)">{{`[${ langData.useBtn }]`}}</a><a id="u_c_6YH561" href="javascript:;" v-show="packItem['send_type'] == 'sendSerial'" :class="[`normal txt-size popup-title-color`,`u_c_6YH561`]" @click="u_c_6YH561_event_QX7K17($event,packItem.award_code)">{{`[${ langData.copyAndGoExchange }]`}}</a></td></tr></tbody></table><div id="u_c_A18C63"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_A18C63`]" ></div></div><a id="u_c_207I64" href="javascript:;" :class="[`normal popup-close`,`u_c_207I64`]" @click="u_c_207I64_event_DMX517($event)"></a></div></div><div id="u_c_9Z7B65"  v-show="compData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup`,`u_c_9Z7B65`]" @click="u_c_9Z7B65_event_TETB35($event)"><div id="u_c_F5DD66"  :class="[`normal popup-content-small`,`u_c_F5DD66`]" @click="u_c_F5DD66_event_U82518($event)"><div id="u_c_V98X67"  :class="[`normal popup-title-color popup-title`,`u_c_V98X67`]" >{{`${ pageData.tips }`}}</div><a id="u_c_CV5E69" href="javascript:;" :class="[`normal sure`,`u_c_CV5E69`]" @click="u_c_CV5E69_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_8L7W71" href="javascript:;" :class="[`normal popup-close`,`u_c_8L7W71`]" @click="u_c_8L7W71_event_DMX517($event)"></a></div></div><div id="u_c_VRJF72"  v-show="compData.previewPopup == 'previewGift' || pageData.seeGiftPopupState" :class="[`normal popup`,`u_c_VRJF72`]" @click="u_c_VRJF72_event_TETB35($event)"><div id="u_c_6HXR73"  :class="[`normal popup-content-small`,`u_c_6HXR73`]" @click="u_c_6HXR73_event_U82518($event)"><div id="u_c_UORR74"  :class="[`normal popup-title-color popup-title`,`u_c_UORR74`]" >{{`${ langData.checkGiftBtn }`}}</div><div id="u_c_8KE031"  :class="[`normal `,`u_c_8KE031`]" ><table id="u_c_87FO32"  :class="[`normal`,`u_c_87FO32`]" ><tbody id="u_c_PR8033"  :class="[`normal`,`u_c_PR8033`]" ><tr id="u_c_CZYQ34"  v-for="(seeItem, seeIndex) in pageData.seeGift" :key="seeIndex" :class="[`normal border-color  tr `,`u_c_CZYQ34`]" ><td id="u_c_EDXO35"  :class="[`normal td border-color txt-size txt-color`,`u_c_EDXO35`]" ><img id="u_c_BVS636"  :src="seeItem.pic" v-show="seeItem.pic" :class="[`normal`,`u_c_BVS636`]" /></td><td id="u_c_NLX637"  :class="[`normal td border-color txt-size txt-color`,`u_c_NLX637`]" ><div id="u_c_NWC738"  v-html="seeItem.name" :class="[`normal`,`u_c_NWC738`]" ></div></td></tr></tbody></table></div><a id="u_c_A47S77" href="javascript:;" :class="[`normal popup-close`,`u_c_A47S77`]" @click="u_c_A47S77_event_DMX517($event)"></a></div></div><div id="u_c_5CEN78"  v-show="compData.previewPopup == 'daoju' || pageData.propsPopupState" :class="[`normal popup`,`u_c_5CEN78`]" @click="u_c_5CEN78_event_TETB35($event)"><div id="u_c_B8SU79"  :class="[`normal popup-content-big`,`u_c_B8SU79`]" @click="u_c_B8SU79_event_U82518($event)"><div id="u_c_DY3E80"  :class="[`normal popup-title popup-title-color`,`u_c_DY3E80`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_1U1082"  :class="[`normal`,`u_c_1U1082`]" ><div id="u_c_3XQE83"  :class="[`normal`,`u_c_3XQE83`]" ><div id="u_c_F0U284"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_F0U284`]" ></div></div><img id="u_c_Z47085"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_Z47085`]" /></div><a id="u_c_AYE286" href="javascript:;" :class="[`normal sure`,`u_c_AYE286`]" @click="u_c_AYE286_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_AY1I88"  v-html="langData.daojuTips" :class="[`normal tips-color txt-size`,`u_c_AY1I88`]" ></div><a id="u_c_612G89" href="javascript:;" :class="[`normal popup-close`,`u_c_612G89`]" @click="u_c_612G89_event_DMX517($event)"></a></div></div><div id="u_c_6QX790"  v-show="compData.previewPopup == 'youhuiquan' || pageData.quanPopupState" :class="[`normal popup`,`u_c_6QX790`]" @click="u_c_6QX790_event_TETB35($event)"><div id="u_c_D5F091"  :class="[`normal popup-content-big`,`u_c_D5F091`]" @click="u_c_D5F091_event_U82518($event)"><div id="u_c_60LO92"  :class="[`normal popup-title popup-title-color`,`u_c_60LO92`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_XYU694"  :class="[`normal`,`u_c_XYU694`]" ><div id="u_c_5JF295"  :class="[`normal`,`u_c_5JF295`]" ><div id="u_c_EQXC96"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_EQXC96`]" ></div></div><img id="u_c_V4J897"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_V4J897`]" /></div><a id="u_c_XNP598" href="javascript:;" :class="[`normal  sure`,`u_c_XNP598`]" @click="u_c_XNP598_event_35V252($event)">{{`${ langData.useBtn }`}}</a><a id="u_c_WXSX105" href="javascript:;" :class="[`normal popup-close`,`u_c_WXSX105`]" @click="u_c_WXSX105_event_DMX517($event)"></a></div></div><div id="u_c_1RDB106"  v-show="compData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup`,`u_c_1RDB106`]" @click="u_c_1RDB106_event_TXZS38($event)"><div id="u_c_3KAF107"  :class="[`normal popup-content-small`,`u_c_3KAF107`]" @click="u_c_3KAF107_event_EKU139($event)"><div id="u_c_C3XY108"  :class="[`normal popup-title popup-title-color`,`u_c_C3XY108`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_4L93110"  :class="[`normal`,`u_c_4L93110`]" ><div id="u_c_29SD111"  :class="[`normal txt-size txt-color`,`u_c_29SD111`]" >{{`${ langData.giftCode }：${ pageData.curGiftName }`}}</div><a id="u_c_AWGX113" href="javascript:;" :class="[`normal txt-size popup-title-color`,`u_c_AWGX113`]" @click="u_c_AWGX113_event_QX7K17($event)">{{`[${ langData.copy }]`}}</a></div><div id="u_c_237H115" href="javascript:;" :class="[`${ compData.copyTipsState ? '' : 'hide' }`,`normal txt-size txt-color`,`u_c_237H115`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_08YN117" href="javascript:;" :class="[`normal popup-close`,`u_c_08YN117`]" @click="u_c_08YN117_event_KBHJ41($event)"></a><a id="u_c_9GXE118" href="javascript:;" :class="[`normal sure`,`u_c_9GXE118`]" @click="u_c_9GXE118_event_YU9U68($event)">{{`${ langData.gotoExchange }`}}</a></div></div><div id="u_c_B8W2120"  v-show="compData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup`,`u_c_B8W2120`]" @click="u_c_B8W2120_event_TETB35($event)"><div id="u_c_85YY121"  :class="[`normal popup-content-big`,`u_c_85YY121`]" @click="u_c_85YY121_event_U82518($event)"><div id="u_c_CU24122"  :class="[`normal popup-title popup-title-color`,`u_c_CU24122`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_8739124"  v-html="compData.infoContent" :class="[`normal txt-size txt-color`,`u_c_8739124`]" ></div><a id="u_c_W64O125" href="javascript:;" :class="[`normal popup-close`,`u_c_W64O125`]" @click="u_c_W64O125_event_DMX517($event)"></a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"infoContent":`1.活动介绍
（1）【成神归来 每日赠礼】
①活动期间，每日通过官网储值任意金额，即可领取首充奖励；
②当日首充奖励需在当日领取完毕，逾期失效，不可补领；

（2）【九考特训 签到送好礼】
①活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、7、12、14天后，即可领取签到奖励；
②每个档位的奖励，每个账号只能领取一次；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


（3）【天使的选择】
①活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒
②消耗一张抽奖券可以进行对应次数开盲盒，随机获得奖池内奖励
③抽奖券不会进行每天重置，需要在活动期间内进行使用，逾期无效。

（4）【成神祝福赠礼】
①活动期间，在【天使盲盒 】中累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；
②累计消耗数量针对整个活动期间进行统计，不会进行每天重置；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


2.奖励发放
奖励将会直接发放至游戏内邮件处，可通过游戏内邮件查收

3.活动最终解释权归《斗罗大陆3D：魂师对决》运营团队所有。`,"copyTipsState":false,"previewPopup":``},"zh-CN":{"infoContent":`首储赠礼
活动期间，通过【官网储值页面】任意渠道成功储值任意金额，即可领取奖励，每个账号只能领取一次；
未领取的奖励可在活动结束后7天内继续领取，7天后失效；

每日签到送不停
活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、5、7天后，即可领取签到奖励；
每个档位的奖励，每个账号只能领取一次；
未领取的奖励可在活动结束后7天内继续领取，7天后失效；
豪华礼盒
活动期间，通过【官网储值页面】任意渠道储值，每天累计储值金额每次达到19.99USD，都会获得一张抽奖券；
消耗一张抽奖券可以进行一次抽奖，随机获得奖池内奖励；
单日获得抽奖券上限100张；
抽奖券不会进行每天重置，需要在活动期间内进行使用，逾期无效;
二重好礼
活动期间，累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；
未领取的奖励可在活动结束后7天内继续领取，7天后失效；`,"copyTipsState":false,"previewPopup":``},"zh-TW":{"infoContent":`首儲贈禮
活動期間，通過【官網儲值頁面】任意管道成功儲值任意金額，即可領取獎勵，每個帳號只能領取一次；
未領取的獎勵可在活動結束後7天內繼續領取，7天後失效；

每日簽到送不停
活動期間，每日登入活動頁面，即可完成簽到，累計簽到天數達到1、3、5、7天後，即可領取簽到獎勵；
每個檔位的獎勵，每個帳號只能領取一次；
未領取的獎勵可在活動結束後7天內繼續領取，7天后失效；
豪華禮包
活動期間，通過【官網儲值頁面】任意管道儲值，每天累計儲值金額每次達到19.99USD，都會獲得一張抽獎券；
消耗一張抽獎券可以進行一次抽獎，隨機獲得獎池內獎勵；
單日獲得抽獎券上限100張；
抽獎券不會進行每天重置，需要在活動期間內進行使用，逾期無效;
二重好禮
活動期間，累計消耗的抽獎券達到一定的數量，可以解鎖領取對應的獎勵；
未領取的獎勵可在活動結束後7天內繼續領取，7天后失效；`,"copyTipsState":false,"previewPopup":``},"en-US":{"infoContent":`1st Top-up Gift
During the event, top up on Puzzles & Survival's official website to obtain a reward. The reward can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Daily Sign-in Reward
Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.
Each tier of rewards can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

Deluxe Supply Box
During the event, every $19.99 you top up every day via Puzzles & Survival's official website will grant you a Lucky Ticket.
Use a Lucky Ticket to draw once to get random rewards.
You can obtain up to 100 Lucky Tickets every day.
Your Lucky Tickets won't reset every day, but be sure to use them before the event ends.

Bonus Gift
Corresponding rewards will be unlocked when the total number of Lucky Tickets you used reaches a certain amount.
Unclaimed rewards will expire 7 days after the event ends.`,"copyTipsState":false,"previewPopup":``},"ja-JP":{"infoContent":`初回チャージ ボーナス
イベント期間中、「公式チャージ画面」にて任意の決済方法で任意の金額をチャージすると、ボーナスを受け取れます！（1つのアカウントにつき1回のみ）
未受領のボーナスはイベント終了から7日間は受け取ることができます。

毎日ログイン　ボーナス続々
イベント期間中、毎日イベント画面からログインするとサインインが完了します。合計サインイン日数が1、3、5、7日に到達すると、対応するボーナスを受け取れます。
1つのアカウントにつき各ボーナスを1回ずつ受取可能
未受領のボーナスはイベント終了から7日間は受け取ることができます。
豪華記念ギフト
イベント期間中、「公式チャージ画面」にて任意の決済方法で一日の合計チャージが19.99ドルに達するたびに、抽選券を獲得できます。
1枚の抽選券を消費し、ランダムボーナスを獲得できます。
1日につき最大100枚の抽選券を獲得できます。
抽選券はイベント期間中に更新されず、イベント終了後に使用できなくなります。
豪華ボーナス
イベント期間中、抽選で合計消費した抽選券の枚数が一定値に達すると対応するボーナスを獲得できます。
未受領のボーナスはイベント終了から7日間は受け取ることができます。`,"copyTipsState":false,"previewPopup":``},"ko-KR":{"infoContent":`첫 충전 
혜택
이벤트 기간에 공식 결제 플랫폼에서 금액 관계 없이 충전만 하면 보상을 획득합니다. (계정당 한 번만 가능!)
"미수령 보상은 이벤트 종료 후 7일 내에만 수령 가능하며, 그 후에는 사라집니다."

매일 출석하면 선물이 팡팡
"이벤트 기간 동안 이벤트 페이지에 매일 접속하여 출석을 완료하면, 누적 출석 일수 1, 3, 5, 7일마다 출석 보상을 획득합니다."
단계별 보상은 계정당 한 번만 받을 수 있습니다.
"미수령 보상은 이벤트 종료 후 7일 내에만 수령 가능하며, 그 후에는 사라집니다."
축제 호화 선물함
이벤트 기간 동안 공식 결제 플랫폼에서 19.99USD를 충전할 때마다 뽑기권 한 장이 주어집니다. 누적 충전 금액이 매일 리셋됩니다.
뽑기권 한 장을 사용해 뽑기를 한 번 돌리면 보상풀의 보상을 랜덤으로 획득합니다.
뽑기권은 일일 최대 100장까지만 획득 가능합니다.
"뽑기권은 다음 날에도 초기화되지 않으나 이벤트 기간 내에 사용하셔야 하며, 기간 종료 시 무효가 됩니다."
더블 보너스
"이벤트 기간 동안 뽑기권 누적 소모량이 일정 개수에 도달하면, 상응하는 보상을 받을 수 있습니다."
"미수령 보상은 이벤트 종료 후 7일 내에만 수령 가능하며, 그 후에는 사라집니다."`,"copyTipsState":false,"previewPopup":``},"th-TH":{"infoContent":`เติมครั้งแรกมีรางวัล
ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สำเร็จ ก็สามารถรับรางวัลได้ (รับได้บัญชีละ 1 ครั้ง)
สามารถรับรางวัลที่ยังไม่ได้รับต่อภายใน 7 วันหลังกิจกรรมสิ้นสุดได้

เช็คอินแล้ว รับรางวัลทันที
"ทุกวันที่เปิดหน้ากิจกรรมในช่วงกิจกรรม ก็จะถือว่าเช็คอินเสร็จสิ้น เมื่อเช็คอินสะสมครบ 1, 3, 5 และ 7 วัน จะรับรางวัลเช็คอินได้"
แต่ละบัญชีสามารถรับรางวัลได้ระดับละ 1 ครั้ง
สามารถรับรางวัลที่ยังไม่ได้รับต่อภายใน 7 วันหลังกิจกรรมสิ้นสุดได้
ลุ้นรับรางวัลใหญ่แพ็กเทศกาลดนตรี
ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สะสมครบครั้งละ 19.99USD ก็จะได้รับคูปองจับรางวัล 1 ใบ
ใช้คูปองจับรางวัล 1 ใบ จะจับรางวัลได้ 1 ครั้ง และสุ่มได้รางวัลภายใน Prize Pool :
รับคูปองจับรางวัลได้สูงสุดวันละ 100 ใบ
คูปองจับรางวัลจะไม่ถูกรีเซ็ตทุกวัน แต่ต้องใช้ในช่วงกิจกรรมเท่านั้น
รางวัล 2 ชั้น
ช่วงกิจกรรมใช้คูปองจับรางวัลถึงจำนวนที่กำหนด ก็สามารถรับรางวัลที่สอดคล้องได้
สามารถรับรางวัลที่ยังไม่ได้รับต่อภายใน 7 วันหลังกิจกรรมสิ้นสุดได้`,"copyTipsState":false,"previewPopup":``},"vi-VN":{"infoContent":`Tặng quà nạp đầu
"Trong thời gian hoạt động, nạp mức bất kỳ trên kênh bất kỳ là có thưởng, mỗi tài khoản chỉ được lấy một lần;"
"Thưởng chưa lấy có thể lấy tiếp trong 7 ngày sau khi kết thúc hoạt động, 7 ngày sau vô hiệu;"

Điểm Danh Hàng Ngày Nhận Quà Liền Tay
"Trong thời gian hoạt động, đăng nhập giao diện hoạt động mỗi ngày là hoàn thành điểm danh, sau khi điểm danh đến 1, 3, 5, 7 ngày là được nhận thưởng điểm danh;"
"Mỗi mức thưởng, mỗi tài khoản chỉ được lấy một lần;"
"Thưởng chưa lấy có thể lấy tiếp trong 7 ngày sau khi kết thúc hoạt động, 7 ngày sau vô hiệu;"
Thưởng thắng Gói Hội Âm Nhạc
"Trong thời gian hoạt động, Nạp thông qua kênh bất kỳ, mỗi lần tích lũy nạp đến 19.99 USD, để nhận một tấm Vé Rút Thưởng;"
"Tiêu phí một tấm Vé Rút Thưởng là có thể rút thưởng một lần, nhận thưởng ngẫu nhiên trong quỹ thưởng;"
Mỗi ngày giới hạn nhận 100 tấm Vé Rút Thưởng;
"Vé Rút Thưởng sẽ không reset hàng ngày, phải sử dụng trong thời gian diễn ra hoạt động, quá hạn vô hiệu;"
Quà Thêm
"Trong thời gian hoạt động, tích lũy tiêu hao số Vé Rút Thưởng chỉ định, là mở khóa phần thưởng tương ứng;"
"Thưởng chưa lấy có thể lấy tiếp trong 7 ngày sau khi kết thúc hoạt động, 7 ngày sau vô hiệu;"`,"copyTipsState":false,"previewPopup":``},"de-DE":{"infoContent":`1. Auflade-Geschenk
Lade w?hrend des Events auf der offiziellen Webseite von Puzzles & Survival auf, um eine Belohnung zu erhalten. Die Belohnung kann nur einmal pro Konto abgeholt werden.
Nicht abgeholte Belohnungen verfallen 7 Tage nach Ende des Events.

T?gliche Anmeldebelohnung
Logge dich jeden Tag auf der Eventseite an, um dich anzumelden. Melde dich für 1/3/5/7 Tag(e) an, um Anmeldebelohnungen zu erhalten.
Jede Belohnungsstufe kann nur einmal pro Konto abgeholt werden.
Nicht abgeholte Belohnungen verfallen 7 Tage nach Ende des Events.
Gewinne fantastische Belohnungen aus dem Musikfest-Paket!
"W?hrend des Events erh?ltst du für jede $19.99, die du jeden Tag über die offizielle Webseite von Puzzles & Survival aufl?dst, ein Glücksticket.
"
Verwende ein Glücksticket, um einmal zu ziehen und um zuf?llige Belohnungen zu erhalten.
Du kannst jeden Tag bis zu 100 Glückstickets erhalten.
Deine Glückstickets werden nicht jeden Tag zurückgesetzt, aber verwende sie unbedingt, bevor das Event endet.
Bonus-Geschenk
Die entsprechenden Belohnungen werden entsperrt, wenn die Gesamtzahl der von dir verwendeten Glückstickets eine bestimmte Menge erreicht.
Nicht abgeholte Belohnungen verfallen 7 Tage nach Ende des Events.
`,"copyTipsState":false,"previewPopup":``},"fr-FR":{"infoContent":`Cadeau de 1ère de Recharge
Pendant l'événement, rechargez votre compte sur le site officiel de Puzzles & Survival pour obtenir une récompense. La récompense ne peut être réclamée qu'une fois par compte.
Les récompenses non réclamées expireront 7 jours après la fin de l'événement.

Récompense de Connexion Quotidienne
Connectez-vous à la page de l'événement tous les jours pour vous connecter. Connectez-vous pendant 1/3/5/7 jour(s) pour réclamer les récompenses de connexion.
Chaque niveau de récompense ne peut être réclamé qu'une fois par compte.
Les récompenses non réclamées expireront 7 jours après la fin de l'événement.
?Gana recompensas increíbles con el paquete del Festival musical!
"Pendant l'événement, chaque fois que vous rechargerez 19,99 $ par jour via le site officiel de Puzzles & Survival, vous obtiendrez un Ticket Chance.
"
Utilisez un Ticket Chanceux pour tirer au sort une fois et obtenir des récompenses aléatoires.
Vous pouvez obtenir jusqu'à 100 Tickets Chanceux par jour.
Vos Tickets Chanceux ne seront pas remis à zéro tous les jours, mais assurez-vous de les utiliser avant la fin de l'événement.
Cadeau Bonus
Les récompenses correspondantes seront débloquées lorsque le nombre total de Tickets Chanceux Tickets que vous avez utilisés atteindra un certain montant.
Les récompenses non réclamées expireront 7 jours après la fin de l'événement.
`,"copyTipsState":false,"previewPopup":``},"es-ES":{"infoContent":`Regalo de la 1.a recarga
Durante el evento, haz una recarga en el sitio web oficial de Puzzles & Survival para obtener una recompensa. La recompensa solo se puede reclamar una vez por cuenta.
Las recompensas sin reclamar caducarán 7 días después de que finalice el evento.

Recompensa de inscripción diaria
Ingresa a la página del evento todos los días para registrarte. Regístrate por 1/3/5/7 día(s) para reclamar las recompensas de inicio de sesión.
Cada nivel de recompensas solo se puede reclamar una vez por cuenta.
Las recompensas sin reclamar caducarán 7 días después de que finalice el evento.
Vinci fantastiche ricompense dal Pacchetto Festival Musicale!
Durante el evento, recibirás un ticket de la suerte por cada $19.99 que recargues todos los días en el sitio web oficial de Puzzles & Survival.
Usa un ticket de la suerte para sortear una vez y conseguir recompensas aleatorias.
Puedes obtener hasta 100 tickets de la suerte por día.
Tus tickets de la suerte no se reiniciarán cada día, pero asegúrate de usarlos antes de que termine el evento.
Regalo de bonificación
Las recompensas correspondientes se desbloquearán cuando la cantidad total de tickets de la suerte que hayas utilizado alcance una cantidad determinada.
Las recompensas sin reclamar caducarán 7 días después de que finalice el evento.
`,"copyTipsState":false,"previewPopup":``},"pt-PT":{"infoContent":`1o presente de recarga
Durante o evento, fa?a uma recarga no site oficial do Puzzles & Survival para obter uma recompensa. A recompensa só pode ser resgatada uma vez por conta.
As recompensas n?o reclamadas expirar?o 7 dias após o término do evento.

Recompensa de Login Diário
Fa?a login na página do evento todos os dias para fazer entrar. Fa?a login por 1/3/5/7 dia(s) para reivindicar recompensas de login.
Cada nível de recompensas só pode ser reivindicado uma vez por conta.
As recompensas n?o reclamadas expirar?o 7 dias após o término do evento.
Win geweldige beloningen uit het Muziekfestival Pakket!
"Durante o evento, cada $19,99 que você recarregar todos os dias através do site oficial do Puzzles & Survival, concederá a você um Bilhete da Sorte.
"
Use um Bilhete da Sorte para sortear uma vez e obter recompensas aleatórias.
Você pode obter até 100 Bilhetes da Sorte todos os dias.
Seus Bilhetes da Sorte n?o ser?o zerados todos os dias, mas certifique-se de usá-los antes do fim do evento.
Presente B?nus
As recompensas correspondentes ser?o desbloqueadas quando o número total de Bilhetes da Sorte que você usou atingir um determinado valor.
As recompensas n?o reclamadas expirar?o 7 dias após o término do evento.
`,"copyTipsState":false,"previewPopup":``},"it-IT":{"infoContent":`1mo Regalo Ricarica
Durante l'evento, ricarica sul sito ufficiale di Puzzles & Survival per ottenere una ricompensa. Il premio può essere richiesto solo una volta per account.
Sudah klaim

Ricompensa Accesso Giornaliero
Accedi alla pagina dell'evento ogni giorno per accedere. Accedi per 1/3/5/7 giorno/i per richiedere i premi di accesso.
Ogni livello di premi può essere richiesto solo una volta per account.
I premi non riscossi scadranno 7 giorni dopo la fine dell'evento.
Wygraj fantastyczne nagrody z pakietu Festiwalu Muzycznego!
Durante l'evento, ogni $19,99 che ricarichi tramite il sito ufficiale di Puzzles & Survival ti garantirà un Biglietto Fortunato.
Usa un Biglietto Fortuna per pescare una volta per ottenere ricompense casuali.
Puoi ottenere fino a 100 Biglietti Fortuna ogni giorno.
I tuoi biglietti fortunati non verranno ripristinati ogni giorno, ma assicurati di utilizzarli prima della fine dell'evento.
Regalo Bonus
Le ricompense corrispondenti verranno sbloccate quando il numero totale di biglietti fortunati che hai utilizzato raggiunge un determinato importo.
I premi non riscossi scadranno 7 giorni dopo la fine dell'evento.
`,"copyTipsState":false,"previewPopup":``},"tr-TR":{"infoContent":`1. Yükleme Hediyesi
Etkinlikte bir ödül almak için Puzzles & Survival'ın resmi sitesinde yükleme yap. Her hesap başına yalnızca bir kez ödül talep edilebilir.
Dituntut

Günlük Giriş Ödülü
Oturum açmak için her gün etkinlik sayfasına giriş yap. Oturum ödüllerini talep etmek için 1/3/5/7 gün giriş yap.
"Her ödül katmanı, hesap başına yalnızca bir kez talep edilebilir."
Talep edilmeyen ödüllerin geçerliliği etkinlikten 7 gün sonra sona erer.
Ganhe fantásticas recompensas do Pacote Festival de Música!
"Etkinlik boyunca, Puzzles & Survival'ın resmi web sitesi aracılığıyla her gün yüklediğin her $19,99 sana bir Şans Bileti verecek."
Çekilişten rasgele ödüller almak için bir Şans Bileti kullan.
Her gün 100 adede kadar Şans Bilet elde edebilirsin.
"Şans Biletlerin her gün sıfırlanmayacak, ancak bunları etkinlik sona ermeden kullandığından emin ol."
Bonus Hediye
"İlgili ödüllerin kilidi, kullandığın toplam Şans Bileti sayısı belirli bir miktara ulaştığında açılacak."
Talep edilmeyen ödüllerin geçerliliği etkinlikten 7 gün sonra sona erer.
`,"copyTipsState":false,"previewPopup":``},"pl-PL":{"infoContent":`Prezent 1wszego doładowania
"Podczas wydarzenia doładuj konto na oficjalnej stronie Puzzles & Survival, aby otrzymać nagrodę. Nagroda może być odebrana tylko raz na jedno konto."
Nieodebrane nagrody wygasną 7 dni po zakończeniu wydarzenia.

Nagroda dziennego logowania
"Zaloguj się na stronie wydarzenia każdego dnia, aby zaliczyć dzienne logowanie. Zaloguj się przez 1/3/5/7 dni, aby odebrać nagrody za logowanie."
Każdy poziom nagród może być odebrany tylko raz na jedno konto.
Nieodebrane nagrody wygasną 7 dni po zakończeniu wydarzenia.
Откройте Набор музыкального фестиваля и получите награды!
"Podczas wydarzenia, każda kwota 19,99 USD, którą doładujesz codziennie za pośrednictwem oficjalnej strony Puzzles & Survival, przyzna Ci Szczęśliwy Bilet.
"
Użyj szczęśliwego biletu w losowaniu i otrzymaj losową nagrodę.
Codziennie możesz odebrać aż do 100 szczęśliwych biletów.
"Twoje szczęśliwe bilety nie będą resetowane każdego dnia, ale pamiętaj, aby użyć ich przed zakończeniem wydarzenia."
Prezent bonusu
"Odpowiednie nagrody zostaną odblokowane, gdy łączna liczba wykorzystanych przez Ciebie szczęśliwych biletów osiągnie określoną wartość."
Nieodebrane nagrody wygasną 7 dni po zakończeniu wydarzenia.
`,"copyTipsState":false,"previewPopup":``},"id-ID":{"infoContent":``,"copyTipsState":false,"previewPopup":``},"ar-SA":{"infoContent":``,"copyTipsState":false,"previewPopup":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const { toClipboard } = useClipboard();

const showTips = inject("showTips", (txt, code) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const isIosAppWebview = window?.webkit?.messageHandlers?.callSDKMethodWithParameters;


const defaultServerItem = [
  { sid: "", id: "", sname: "" },
]
const defaultRoleItem = [{ roleID: "", roleName: getLangTxt("selectRole") }]
const curPlatform =pagePlatform;

const init = () => {
  compData.bindPopupState = false
  compData.bagPopupState = false
  compData.infoPopupState = false
  compData.tipsPopupState = false
  compData.propsPopupState = false
  compData.quanPopupState = false
  compData.seeGiftPopupState = false
  compData.giftCodePopupState = false
  compData.previewPopup = "";

  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)


}

init()

watch(
  () => pageData.isLogin,
  async (value) => {
    if (!value) return
    await initServerList()
    initLinkServer()
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value || !value.sid) return
    await initRoleList()
    initLinkRole()
  }
)

const initServerList = async () => {
  pageData.serverList = []
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
    omnion: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=listServerNew`,
  }
  let res = await request.getJSON(link[curPlatform])
  if (res.result == 1) {
    res?.data?.all_servers
      ? pageData.serverList.push(...res.data.all_servers)
      : "";
    res?.data?.recent_servers
      ? pageData.recentServerList.push(...res.data.recent_servers)
      : "";
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
    omnion: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getMobileGameRole`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const bindRole = async () => {
  const link = {
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=bind`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
      server_sid: pageData.serverItem.id,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(
        encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)
      ),
      server_name: pageData.serverItem.sname,
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.serverName = res.data.bind_data.server_name
    pageData.roleName = res.data.bind_data.role_name
    pageData.bindPopupState = false
    pageData.isBind = true
    try {
      window.__updatePointUploadCookie(
        "role_id",
        res.data.bind_data.role_id
      )
      window.__updatePointUploadCookie(
        "role_name",
        res.data.bind_data.role_name
      )
      window.__updatePointUploadCookie(
        "server_id",
        res.data.bind_data.server_id
      )
    } catch (error) {}
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
}

watch(()=>compData.copyTipsState,value=>{
  if(value){
    setTimeout(()=>{
      compData.copyTipsState = false;
    },2000)
  }
});
      // 绑定弹窗的click事件
      const u_c_YLOM18_event_F8M123= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_EZ8J19_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_DKO437_event_QSVC19= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
  alert(getLangTxt("selectServer"))
  return
}
if (!pageData.roleIndex) {
  alert(getLangTxt("selectRole"))
  return
}
if (!canClickBindSubmit.value) return
canClickBindSubmit.value = false
await bindRole()
canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_4AAC40_event_DMX517= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗的click事件
      const u_c_B7PH41_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_37AZ42_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 查看的click事件
      const u_c_7LGZ59_event_1JVM17= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 复制并前往的click事件
      const u_c_6YH561_event_QX7K17= async (e,code)=>{
        try {try{
  await toClipboard(code);
}catch(e){}

bridge.openInline(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_207I64_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 提示语弹窗的click事件
      const u_c_9Z7B65_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_F5DD66_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_CV5E69_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_8L7W71_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 查看奖励弹窗的click事件
      const u_c_VRJF72_event_TETB35= async (e)=>{
        try {pageData.seeGiftPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_6HXR73_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_A47S77_event_DMX517= async (e)=>{
        try {pageData.seeGiftPopupState = false} catch (error) {console.log(error)}
      };
      // 道具领取成功弹窗的click事件
      const u_c_5CEN78_event_TETB35= async (e)=>{
        try {pageData.propsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_B8SU79_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_AYE286_event_YU9U68= async (e)=>{
        try {pageData.propsPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_612G89_event_DMX517= async (e)=>{
        try {pageData.propsPopupState = false} catch (error) {console.log(error)}
      };
      // 优惠券领取成功弹窗的click事件
      const u_c_6QX790_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_D5F091_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_XNP598_event_35V252= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_WXSX105_event_DMX517= async (e)=>{
        try {pageData.quanPopupState = false} catch (error) {console.log(error)}
      };
      // 序列号领取成功弹窗的click事件
      const u_c_1RDB106_event_TXZS38= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_3KAF107_event_EKU139= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_AWGX113_event_QX7K17= async (e)=>{
        try {await toClipboard(pageData.curGiftName);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_08YN117_event_KBHJ41= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 前往兑换的click事件
      const u_c_9GXE118_event_YU9U68= async (e)=>{
        try {try{
  await toClipboard(pageData.curGiftName);
  compData.copyTipsState = true;
  await utils.sleep(1)
}catch(e){}

bridge.openInline(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 活动规则弹窗的click事件
      const u_c_B8W2120_event_TETB35= async (e)=>{
        try {pageData.infoPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_85YY121_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_W64O125_event_DMX517= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.default{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.default{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.default{
.u_c_DCJ823.normal{
position:relative;

}
}.default{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_0BRZ33.normal{
position:relative;

}
}.default{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.default{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.default{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.default{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.default{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_7SYQ47.normal{
position:relative;

}
}.default{
.u_c_DR2P48.normal{
position:relative;

}
}.default{
.u_c_4DR950.normal{
position:relative;

}
}.default{
.u_c_3MAG52.normal{
position:relative;

}
}.default{
.u_c_V45S53.normal{
position:relative;

}
}.default{
.u_c_6VDD54.normal{
position:relative;

}
}.default{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_0P5L58.normal{
position:relative;

}
}.default{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.default{
.u_c_6YH561.normal{
position:relative;

}
}.default{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.default{
.u_c_9Z7B65.normal{
position:relative;

}
}.default{
.u_c_F5DD66.normal{
position:relative;

}
}.default{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.default{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.default{
.u_c_VRJF72.normal{
position:relative;

}
}.default{
.u_c_6HXR73.normal{
position:relative;

}
}.default{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.default{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.default{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.default{
.u_c_PR8033.normal{
position:relative;

}
}.default{
.u_c_CZYQ34.normal{
position:relative;

}
}.default{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.default{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.default{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.default{
.u_c_NWC738.normal{
position:relative;

}
}.default{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.default{
.u_c_5CEN78.normal{
position:relative;

}
}.default{
.u_c_B8SU79.normal{
position:relative;

}
}.default{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.default{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_3XQE83.normal{
position:relative;

}
}.default{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.default{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.default{
.u_c_6QX790.normal{
position:relative;

}
}.default{
.u_c_D5F091.normal{
position:relative;

}
}.default{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.default{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_5JF295.normal{
position:relative;

}
}.default{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.default{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_3KAF107.normal{
position:relative;

}
}.default{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.default{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.default{
.u_c_29SD111.normal{
position:relative;

}
}.default{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.default{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.default{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.default{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_B8W2120.normal{
position:relative;

}
}.default{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.default{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.zh-CN{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.zh-CN{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.zh-CN{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.zh-CN{
.u_c_DCJ823.normal{
position:relative;

}
}.zh-CN{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_0BRZ33.normal{
position:relative;

}
}.zh-CN{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-CN{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.zh-CN{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.zh-CN{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.zh-CN{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.zh-CN{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_7SYQ47.normal{
position:relative;

}
}.zh-CN{
.u_c_DR2P48.normal{
position:relative;

}
}.zh-CN{
.u_c_4DR950.normal{
position:relative;

}
}.zh-CN{
.u_c_3MAG52.normal{
position:relative;

}
}.zh-CN{
.u_c_V45S53.normal{
position:relative;

}
}.zh-CN{
.u_c_6VDD54.normal{
position:relative;

}
}.zh-CN{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.zh-CN{
.u_c_0P5L58.normal{
position:relative;

}
}.zh-CN{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.zh-CN{
.u_c_6YH561.normal{
position:relative;

}
}.zh-CN{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.zh-CN{
.u_c_9Z7B65.normal{
position:relative;

}
}.zh-CN{
.u_c_F5DD66.normal{
position:relative;

}
}.zh-CN{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-CN{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.zh-CN{
.u_c_VRJF72.normal{
position:relative;

}
}.zh-CN{
.u_c_6HXR73.normal{
position:relative;

}
}.zh-CN{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.zh-CN{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-CN{
.u_c_PR8033.normal{
position:relative;

}
}.zh-CN{
.u_c_CZYQ34.normal{
position:relative;

}
}.zh-CN{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.zh-CN{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.zh-CN{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-CN{
.u_c_NWC738.normal{
position:relative;

}
}.zh-CN{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.zh-CN{
.u_c_5CEN78.normal{
position:relative;

}
}.zh-CN{
.u_c_B8SU79.normal{
position:relative;

}
}.zh-CN{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.zh-CN{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.zh-CN{
.u_c_3XQE83.normal{
position:relative;

}
}.zh-CN{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-CN{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.zh-CN{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.zh-CN{
.u_c_6QX790.normal{
position:relative;

}
}.zh-CN{
.u_c_D5F091.normal{
position:relative;

}
}.zh-CN{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.zh-CN{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.zh-CN{
.u_c_5JF295.normal{
position:relative;

}
}.zh-CN{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-CN{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.zh-CN{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_3KAF107.normal{
position:relative;

}
}.zh-CN{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.zh-CN{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.zh-CN{
.u_c_29SD111.normal{
position:relative;

}
}.zh-CN{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.zh-CN{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.zh-CN{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.zh-CN{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-CN{
.u_c_B8W2120.normal{
position:relative;

}
}.zh-CN{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-CN{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.zh-CN{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.zh-TW{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.zh-TW{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.zh-TW{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.zh-TW{
.u_c_DCJ823.normal{
position:relative;

}
}.zh-TW{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_0BRZ33.normal{
position:relative;

}
}.zh-TW{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-TW{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.zh-TW{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.zh-TW{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.zh-TW{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.zh-TW{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_7SYQ47.normal{
position:relative;

}
}.zh-TW{
.u_c_DR2P48.normal{
position:relative;

}
}.zh-TW{
.u_c_4DR950.normal{
position:relative;

}
}.zh-TW{
.u_c_3MAG52.normal{
position:relative;

}
}.zh-TW{
.u_c_V45S53.normal{
position:relative;

}
}.zh-TW{
.u_c_6VDD54.normal{
position:relative;

}
}.zh-TW{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_0P5L58.normal{
position:relative;

}
}.zh-TW{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.zh-TW{
.u_c_6YH561.normal{
position:relative;

}
}.zh-TW{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.zh-TW{
.u_c_9Z7B65.normal{
position:relative;

}
}.zh-TW{
.u_c_F5DD66.normal{
position:relative;

}
}.zh-TW{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-TW{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.zh-TW{
.u_c_VRJF72.normal{
position:relative;

}
}.zh-TW{
.u_c_6HXR73.normal{
position:relative;

}
}.zh-TW{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.zh-TW{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-TW{
.u_c_PR8033.normal{
position:relative;

}
}.zh-TW{
.u_c_CZYQ34.normal{
position:relative;

}
}.zh-TW{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.zh-TW{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.zh-TW{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-TW{
.u_c_NWC738.normal{
position:relative;

}
}.zh-TW{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.zh-TW{
.u_c_5CEN78.normal{
position:relative;

}
}.zh-TW{
.u_c_B8SU79.normal{
position:relative;

}
}.zh-TW{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.zh-TW{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.zh-TW{
.u_c_3XQE83.normal{
position:relative;

}
}.zh-TW{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-TW{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.zh-TW{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.zh-TW{
.u_c_6QX790.normal{
position:relative;

}
}.zh-TW{
.u_c_D5F091.normal{
position:relative;

}
}.zh-TW{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.zh-TW{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.zh-TW{
.u_c_5JF295.normal{
position:relative;

}
}.zh-TW{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-TW{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.zh-TW{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_3KAF107.normal{
position:relative;

}
}.zh-TW{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.zh-TW{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.zh-TW{
.u_c_29SD111.normal{
position:relative;

}
}.zh-TW{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.zh-TW{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.zh-TW{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.zh-TW{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.zh-TW{
.u_c_B8W2120.normal{
position:relative;

}
}.zh-TW{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.zh-TW{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.zh-TW{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.en-US{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.en-US{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.en-US{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.en-US{
.u_c_DCJ823.normal{
position:relative;

}
}.en-US{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_0BRZ33.normal{
position:relative;

}
}.en-US{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.en-US{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.en-US{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.en-US{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.en-US{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_7SYQ47.normal{
position:relative;

}
}.en-US{
.u_c_DR2P48.normal{
position:relative;

}
}.en-US{
.u_c_4DR950.normal{
position:relative;

}
}.en-US{
.u_c_3MAG52.normal{
position:relative;

}
}.en-US{
.u_c_V45S53.normal{
position:relative;

}
}.en-US{
.u_c_6VDD54.normal{
position:relative;

}
}.en-US{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_0P5L58.normal{
position:relative;

}
}.en-US{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.en-US{
.u_c_6YH561.normal{
position:relative;

}
}.en-US{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.en-US{
.u_c_9Z7B65.normal{
position:relative;

}
}.en-US{
.u_c_F5DD66.normal{
position:relative;

}
}.en-US{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.en-US{
.u_c_VRJF72.normal{
position:relative;

}
}.en-US{
.u_c_6HXR73.normal{
position:relative;

}
}.en-US{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.en-US{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.en-US{
.u_c_PR8033.normal{
position:relative;

}
}.en-US{
.u_c_CZYQ34.normal{
position:relative;

}
}.en-US{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.en-US{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.en-US{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.en-US{
.u_c_NWC738.normal{
position:relative;

}
}.en-US{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.en-US{
.u_c_5CEN78.normal{
position:relative;

}
}.en-US{
.u_c_B8SU79.normal{
position:relative;

}
}.en-US{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.en-US{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_3XQE83.normal{
position:relative;

}
}.en-US{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.en-US{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.en-US{
.u_c_6QX790.normal{
position:relative;

}
}.en-US{
.u_c_D5F091.normal{
position:relative;

}
}.en-US{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.en-US{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_5JF295.normal{
position:relative;

}
}.en-US{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.en-US{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_3KAF107.normal{
position:relative;

}
}.en-US{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.en-US{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.en-US{
.u_c_29SD111.normal{
position:relative;

}
}.en-US{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.en-US{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.en-US{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.en-US{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_B8W2120.normal{
position:relative;

}
}.en-US{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.en-US{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.ja-JP{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.ja-JP{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.ja-JP{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.ja-JP{
.u_c_DCJ823.normal{
position:relative;

}
}.ja-JP{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_0BRZ33.normal{
position:relative;

}
}.ja-JP{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ja-JP{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.ja-JP{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.ja-JP{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.ja-JP{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.ja-JP{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_7SYQ47.normal{
position:relative;

}
}.ja-JP{
.u_c_DR2P48.normal{
position:relative;

}
}.ja-JP{
.u_c_4DR950.normal{
position:relative;

}
}.ja-JP{
.u_c_3MAG52.normal{
position:relative;

}
}.ja-JP{
.u_c_V45S53.normal{
position:relative;

}
}.ja-JP{
.u_c_6VDD54.normal{
position:relative;

}
}.ja-JP{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.ja-JP{
.u_c_0P5L58.normal{
position:relative;

}
}.ja-JP{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.ja-JP{
.u_c_6YH561.normal{
position:relative;

}
}.ja-JP{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.ja-JP{
.u_c_9Z7B65.normal{
position:relative;

}
}.ja-JP{
.u_c_F5DD66.normal{
position:relative;

}
}.ja-JP{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ja-JP{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ja-JP{
.u_c_VRJF72.normal{
position:relative;

}
}.ja-JP{
.u_c_6HXR73.normal{
position:relative;

}
}.ja-JP{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.ja-JP{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ja-JP{
.u_c_PR8033.normal{
position:relative;

}
}.ja-JP{
.u_c_CZYQ34.normal{
position:relative;

}
}.ja-JP{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.ja-JP{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.ja-JP{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ja-JP{
.u_c_NWC738.normal{
position:relative;

}
}.ja-JP{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ja-JP{
.u_c_5CEN78.normal{
position:relative;

}
}.ja-JP{
.u_c_B8SU79.normal{
position:relative;

}
}.ja-JP{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.ja-JP{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ja-JP{
.u_c_3XQE83.normal{
position:relative;

}
}.ja-JP{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ja-JP{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.ja-JP{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.ja-JP{
.u_c_6QX790.normal{
position:relative;

}
}.ja-JP{
.u_c_D5F091.normal{
position:relative;

}
}.ja-JP{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.ja-JP{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ja-JP{
.u_c_5JF295.normal{
position:relative;

}
}.ja-JP{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ja-JP{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.ja-JP{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_3KAF107.normal{
position:relative;

}
}.ja-JP{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.ja-JP{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.ja-JP{
.u_c_29SD111.normal{
position:relative;

}
}.ja-JP{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.ja-JP{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.ja-JP{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.ja-JP{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ja-JP{
.u_c_B8W2120.normal{
position:relative;

}
}.ja-JP{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ja-JP{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.ja-JP{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.ko-KR{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.ko-KR{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.ko-KR{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.ko-KR{
.u_c_DCJ823.normal{
position:relative;

}
}.ko-KR{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_0BRZ33.normal{
position:relative;

}
}.ko-KR{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ko-KR{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.ko-KR{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.ko-KR{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.ko-KR{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.ko-KR{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_7SYQ47.normal{
position:relative;

}
}.ko-KR{
.u_c_DR2P48.normal{
position:relative;

}
}.ko-KR{
.u_c_4DR950.normal{
position:relative;

}
}.ko-KR{
.u_c_3MAG52.normal{
position:relative;

}
}.ko-KR{
.u_c_V45S53.normal{
position:relative;

}
}.ko-KR{
.u_c_6VDD54.normal{
position:relative;

}
}.ko-KR{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.ko-KR{
.u_c_0P5L58.normal{
position:relative;

}
}.ko-KR{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.ko-KR{
.u_c_6YH561.normal{
position:relative;

}
}.ko-KR{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.ko-KR{
.u_c_9Z7B65.normal{
position:relative;

}
}.ko-KR{
.u_c_F5DD66.normal{
position:relative;

}
}.ko-KR{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ko-KR{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ko-KR{
.u_c_VRJF72.normal{
position:relative;

}
}.ko-KR{
.u_c_6HXR73.normal{
position:relative;

}
}.ko-KR{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.ko-KR{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ko-KR{
.u_c_PR8033.normal{
position:relative;

}
}.ko-KR{
.u_c_CZYQ34.normal{
position:relative;

}
}.ko-KR{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.ko-KR{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.ko-KR{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ko-KR{
.u_c_NWC738.normal{
position:relative;

}
}.ko-KR{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ko-KR{
.u_c_5CEN78.normal{
position:relative;

}
}.ko-KR{
.u_c_B8SU79.normal{
position:relative;

}
}.ko-KR{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.ko-KR{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ko-KR{
.u_c_3XQE83.normal{
position:relative;

}
}.ko-KR{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ko-KR{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.ko-KR{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.ko-KR{
.u_c_6QX790.normal{
position:relative;

}
}.ko-KR{
.u_c_D5F091.normal{
position:relative;

}
}.ko-KR{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.ko-KR{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ko-KR{
.u_c_5JF295.normal{
position:relative;

}
}.ko-KR{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ko-KR{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.ko-KR{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_3KAF107.normal{
position:relative;

}
}.ko-KR{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.ko-KR{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.ko-KR{
.u_c_29SD111.normal{
position:relative;

}
}.ko-KR{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.ko-KR{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.ko-KR{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.ko-KR{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ko-KR{
.u_c_B8W2120.normal{
position:relative;

}
}.ko-KR{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ko-KR{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.ko-KR{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.th-TH{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.th-TH{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.th-TH{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.th-TH{
.u_c_DCJ823.normal{
position:relative;

}
}.th-TH{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_0BRZ33.normal{
position:relative;

}
}.th-TH{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.th-TH{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.th-TH{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.th-TH{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.th-TH{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_7SYQ47.normal{
position:relative;

}
}.th-TH{
.u_c_DR2P48.normal{
position:relative;

}
}.th-TH{
.u_c_4DR950.normal{
position:relative;

}
}.th-TH{
.u_c_3MAG52.normal{
position:relative;

}
}.th-TH{
.u_c_V45S53.normal{
position:relative;

}
}.th-TH{
.u_c_6VDD54.normal{
position:relative;

}
}.th-TH{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_0P5L58.normal{
position:relative;

}
}.th-TH{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.th-TH{
.u_c_6YH561.normal{
position:relative;

}
}.th-TH{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.th-TH{
.u_c_9Z7B65.normal{
position:relative;

}
}.th-TH{
.u_c_F5DD66.normal{
position:relative;

}
}.th-TH{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.th-TH{
.u_c_VRJF72.normal{
position:relative;

}
}.th-TH{
.u_c_6HXR73.normal{
position:relative;

}
}.th-TH{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.th-TH{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.th-TH{
.u_c_PR8033.normal{
position:relative;

}
}.th-TH{
.u_c_CZYQ34.normal{
position:relative;

}
}.th-TH{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.th-TH{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.th-TH{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.th-TH{
.u_c_NWC738.normal{
position:relative;

}
}.th-TH{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.th-TH{
.u_c_5CEN78.normal{
position:relative;

}
}.th-TH{
.u_c_B8SU79.normal{
position:relative;

}
}.th-TH{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.th-TH{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.th-TH{
.u_c_3XQE83.normal{
position:relative;

}
}.th-TH{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.th-TH{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.th-TH{
.u_c_6QX790.normal{
position:relative;

}
}.th-TH{
.u_c_D5F091.normal{
position:relative;

}
}.th-TH{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.th-TH{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.th-TH{
.u_c_5JF295.normal{
position:relative;

}
}.th-TH{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.th-TH{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_3KAF107.normal{
position:relative;

}
}.th-TH{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.th-TH{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.th-TH{
.u_c_29SD111.normal{
position:relative;

}
}.th-TH{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.th-TH{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.th-TH{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.th-TH{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.th-TH{
.u_c_B8W2120.normal{
position:relative;

}
}.th-TH{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.th-TH{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.th-TH{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.vi-VN{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.vi-VN{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.vi-VN{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.vi-VN{
.u_c_DCJ823.normal{
position:relative;

}
}.vi-VN{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_0BRZ33.normal{
position:relative;

}
}.vi-VN{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.vi-VN{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.vi-VN{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.vi-VN{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.vi-VN{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.vi-VN{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_7SYQ47.normal{
position:relative;

}
}.vi-VN{
.u_c_DR2P48.normal{
position:relative;

}
}.vi-VN{
.u_c_4DR950.normal{
position:relative;

}
}.vi-VN{
.u_c_3MAG52.normal{
position:relative;

}
}.vi-VN{
.u_c_V45S53.normal{
position:relative;

}
}.vi-VN{
.u_c_6VDD54.normal{
position:relative;

}
}.vi-VN{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.vi-VN{
.u_c_0P5L58.normal{
position:relative;

}
}.vi-VN{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.vi-VN{
.u_c_6YH561.normal{
position:relative;

}
}.vi-VN{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.vi-VN{
.u_c_9Z7B65.normal{
position:relative;

}
}.vi-VN{
.u_c_F5DD66.normal{
position:relative;

}
}.vi-VN{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.vi-VN{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.vi-VN{
.u_c_VRJF72.normal{
position:relative;

}
}.vi-VN{
.u_c_6HXR73.normal{
position:relative;

}
}.vi-VN{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.vi-VN{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.vi-VN{
.u_c_PR8033.normal{
position:relative;

}
}.vi-VN{
.u_c_CZYQ34.normal{
position:relative;

}
}.vi-VN{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.vi-VN{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.vi-VN{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.vi-VN{
.u_c_NWC738.normal{
position:relative;

}
}.vi-VN{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.vi-VN{
.u_c_5CEN78.normal{
position:relative;

}
}.vi-VN{
.u_c_B8SU79.normal{
position:relative;

}
}.vi-VN{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.vi-VN{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.vi-VN{
.u_c_3XQE83.normal{
position:relative;

}
}.vi-VN{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.vi-VN{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.vi-VN{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.vi-VN{
.u_c_6QX790.normal{
position:relative;

}
}.vi-VN{
.u_c_D5F091.normal{
position:relative;

}
}.vi-VN{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.vi-VN{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.vi-VN{
.u_c_5JF295.normal{
position:relative;

}
}.vi-VN{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.vi-VN{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.vi-VN{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_3KAF107.normal{
position:relative;

}
}.vi-VN{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.vi-VN{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.vi-VN{
.u_c_29SD111.normal{
position:relative;

}
}.vi-VN{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.vi-VN{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.vi-VN{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.vi-VN{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.vi-VN{
.u_c_B8W2120.normal{
position:relative;

}
}.vi-VN{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.vi-VN{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.vi-VN{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.de-DE{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.de-DE{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.de-DE{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.de-DE{
.u_c_DCJ823.normal{
position:relative;

}
}.de-DE{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_0BRZ33.normal{
position:relative;

}
}.de-DE{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.de-DE{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.de-DE{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.de-DE{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.de-DE{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.de-DE{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_7SYQ47.normal{
position:relative;

}
}.de-DE{
.u_c_DR2P48.normal{
position:relative;

}
}.de-DE{
.u_c_4DR950.normal{
position:relative;

}
}.de-DE{
.u_c_3MAG52.normal{
position:relative;

}
}.de-DE{
.u_c_V45S53.normal{
position:relative;

}
}.de-DE{
.u_c_6VDD54.normal{
position:relative;

}
}.de-DE{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.de-DE{
.u_c_0P5L58.normal{
position:relative;

}
}.de-DE{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.de-DE{
.u_c_6YH561.normal{
position:relative;

}
}.de-DE{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.de-DE{
.u_c_9Z7B65.normal{
position:relative;

}
}.de-DE{
.u_c_F5DD66.normal{
position:relative;

}
}.de-DE{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.de-DE{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.de-DE{
.u_c_VRJF72.normal{
position:relative;

}
}.de-DE{
.u_c_6HXR73.normal{
position:relative;

}
}.de-DE{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.de-DE{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.de-DE{
.u_c_PR8033.normal{
position:relative;

}
}.de-DE{
.u_c_CZYQ34.normal{
position:relative;

}
}.de-DE{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.de-DE{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.de-DE{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.de-DE{
.u_c_NWC738.normal{
position:relative;

}
}.de-DE{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.de-DE{
.u_c_5CEN78.normal{
position:relative;

}
}.de-DE{
.u_c_B8SU79.normal{
position:relative;

}
}.de-DE{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.de-DE{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.de-DE{
.u_c_3XQE83.normal{
position:relative;

}
}.de-DE{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.de-DE{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.de-DE{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.de-DE{
.u_c_6QX790.normal{
position:relative;

}
}.de-DE{
.u_c_D5F091.normal{
position:relative;

}
}.de-DE{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.de-DE{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.de-DE{
.u_c_5JF295.normal{
position:relative;

}
}.de-DE{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.de-DE{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.de-DE{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_3KAF107.normal{
position:relative;

}
}.de-DE{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.de-DE{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.de-DE{
.u_c_29SD111.normal{
position:relative;

}
}.de-DE{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.de-DE{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.de-DE{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.de-DE{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.de-DE{
.u_c_B8W2120.normal{
position:relative;

}
}.de-DE{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.de-DE{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.de-DE{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.fr-FR{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.fr-FR{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.fr-FR{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.fr-FR{
.u_c_DCJ823.normal{
position:relative;

}
}.fr-FR{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_0BRZ33.normal{
position:relative;

}
}.fr-FR{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.fr-FR{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.fr-FR{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.fr-FR{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.fr-FR{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.fr-FR{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_7SYQ47.normal{
position:relative;

}
}.fr-FR{
.u_c_DR2P48.normal{
position:relative;

}
}.fr-FR{
.u_c_4DR950.normal{
position:relative;

}
}.fr-FR{
.u_c_3MAG52.normal{
position:relative;

}
}.fr-FR{
.u_c_V45S53.normal{
position:relative;

}
}.fr-FR{
.u_c_6VDD54.normal{
position:relative;

}
}.fr-FR{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.fr-FR{
.u_c_0P5L58.normal{
position:relative;

}
}.fr-FR{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.fr-FR{
.u_c_6YH561.normal{
position:relative;

}
}.fr-FR{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.fr-FR{
.u_c_9Z7B65.normal{
position:relative;

}
}.fr-FR{
.u_c_F5DD66.normal{
position:relative;

}
}.fr-FR{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.fr-FR{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.fr-FR{
.u_c_VRJF72.normal{
position:relative;

}
}.fr-FR{
.u_c_6HXR73.normal{
position:relative;

}
}.fr-FR{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.fr-FR{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.fr-FR{
.u_c_PR8033.normal{
position:relative;

}
}.fr-FR{
.u_c_CZYQ34.normal{
position:relative;

}
}.fr-FR{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.fr-FR{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.fr-FR{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.fr-FR{
.u_c_NWC738.normal{
position:relative;

}
}.fr-FR{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.fr-FR{
.u_c_5CEN78.normal{
position:relative;

}
}.fr-FR{
.u_c_B8SU79.normal{
position:relative;

}
}.fr-FR{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.fr-FR{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.fr-FR{
.u_c_3XQE83.normal{
position:relative;

}
}.fr-FR{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.fr-FR{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.fr-FR{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.fr-FR{
.u_c_6QX790.normal{
position:relative;

}
}.fr-FR{
.u_c_D5F091.normal{
position:relative;

}
}.fr-FR{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.fr-FR{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.fr-FR{
.u_c_5JF295.normal{
position:relative;

}
}.fr-FR{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.fr-FR{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.fr-FR{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_3KAF107.normal{
position:relative;

}
}.fr-FR{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.fr-FR{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.fr-FR{
.u_c_29SD111.normal{
position:relative;

}
}.fr-FR{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.fr-FR{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.fr-FR{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.fr-FR{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.fr-FR{
.u_c_B8W2120.normal{
position:relative;

}
}.fr-FR{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.fr-FR{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.fr-FR{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.es-ES{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.es-ES{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.es-ES{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.es-ES{
.u_c_DCJ823.normal{
position:relative;

}
}.es-ES{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_0BRZ33.normal{
position:relative;

}
}.es-ES{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.es-ES{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.es-ES{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.es-ES{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.es-ES{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.es-ES{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_7SYQ47.normal{
position:relative;

}
}.es-ES{
.u_c_DR2P48.normal{
position:relative;

}
}.es-ES{
.u_c_4DR950.normal{
position:relative;

}
}.es-ES{
.u_c_3MAG52.normal{
position:relative;

}
}.es-ES{
.u_c_V45S53.normal{
position:relative;

}
}.es-ES{
.u_c_6VDD54.normal{
position:relative;

}
}.es-ES{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.es-ES{
.u_c_0P5L58.normal{
position:relative;

}
}.es-ES{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.es-ES{
.u_c_6YH561.normal{
position:relative;

}
}.es-ES{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.es-ES{
.u_c_9Z7B65.normal{
position:relative;

}
}.es-ES{
.u_c_F5DD66.normal{
position:relative;

}
}.es-ES{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.es-ES{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.es-ES{
.u_c_VRJF72.normal{
position:relative;

}
}.es-ES{
.u_c_6HXR73.normal{
position:relative;

}
}.es-ES{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.es-ES{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.es-ES{
.u_c_PR8033.normal{
position:relative;

}
}.es-ES{
.u_c_CZYQ34.normal{
position:relative;

}
}.es-ES{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.es-ES{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.es-ES{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.es-ES{
.u_c_NWC738.normal{
position:relative;

}
}.es-ES{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.es-ES{
.u_c_5CEN78.normal{
position:relative;

}
}.es-ES{
.u_c_B8SU79.normal{
position:relative;

}
}.es-ES{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.es-ES{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.es-ES{
.u_c_3XQE83.normal{
position:relative;

}
}.es-ES{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.es-ES{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.es-ES{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.es-ES{
.u_c_6QX790.normal{
position:relative;

}
}.es-ES{
.u_c_D5F091.normal{
position:relative;

}
}.es-ES{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.es-ES{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.es-ES{
.u_c_5JF295.normal{
position:relative;

}
}.es-ES{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.es-ES{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.es-ES{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_3KAF107.normal{
position:relative;

}
}.es-ES{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.es-ES{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.es-ES{
.u_c_29SD111.normal{
position:relative;

}
}.es-ES{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.es-ES{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.es-ES{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.es-ES{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.es-ES{
.u_c_B8W2120.normal{
position:relative;

}
}.es-ES{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.es-ES{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.es-ES{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.pt-PT{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.pt-PT{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.pt-PT{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.pt-PT{
.u_c_DCJ823.normal{
position:relative;

}
}.pt-PT{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_0BRZ33.normal{
position:relative;

}
}.pt-PT{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.pt-PT{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.pt-PT{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.pt-PT{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.pt-PT{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_7SYQ47.normal{
position:relative;

}
}.pt-PT{
.u_c_DR2P48.normal{
position:relative;

}
}.pt-PT{
.u_c_4DR950.normal{
position:relative;

}
}.pt-PT{
.u_c_3MAG52.normal{
position:relative;

}
}.pt-PT{
.u_c_V45S53.normal{
position:relative;

}
}.pt-PT{
.u_c_6VDD54.normal{
position:relative;

}
}.pt-PT{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_0P5L58.normal{
position:relative;

}
}.pt-PT{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.pt-PT{
.u_c_6YH561.normal{
position:relative;

}
}.pt-PT{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.pt-PT{
.u_c_9Z7B65.normal{
position:relative;

}
}.pt-PT{
.u_c_F5DD66.normal{
position:relative;

}
}.pt-PT{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.pt-PT{
.u_c_VRJF72.normal{
position:relative;

}
}.pt-PT{
.u_c_6HXR73.normal{
position:relative;

}
}.pt-PT{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.pt-PT{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pt-PT{
.u_c_PR8033.normal{
position:relative;

}
}.pt-PT{
.u_c_CZYQ34.normal{
position:relative;

}
}.pt-PT{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.pt-PT{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.pt-PT{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pt-PT{
.u_c_NWC738.normal{
position:relative;

}
}.pt-PT{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.pt-PT{
.u_c_5CEN78.normal{
position:relative;

}
}.pt-PT{
.u_c_B8SU79.normal{
position:relative;

}
}.pt-PT{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.pt-PT{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.pt-PT{
.u_c_3XQE83.normal{
position:relative;

}
}.pt-PT{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.pt-PT{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.pt-PT{
.u_c_6QX790.normal{
position:relative;

}
}.pt-PT{
.u_c_D5F091.normal{
position:relative;

}
}.pt-PT{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.pt-PT{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.pt-PT{
.u_c_5JF295.normal{
position:relative;

}
}.pt-PT{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.pt-PT{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_3KAF107.normal{
position:relative;

}
}.pt-PT{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.pt-PT{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.pt-PT{
.u_c_29SD111.normal{
position:relative;

}
}.pt-PT{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.pt-PT{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.pt-PT{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.pt-PT{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_B8W2120.normal{
position:relative;

}
}.pt-PT{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.pt-PT{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.it-IT{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.it-IT{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.it-IT{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.it-IT{
.u_c_DCJ823.normal{
position:relative;

}
}.it-IT{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_0BRZ33.normal{
position:relative;

}
}.it-IT{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.it-IT{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.it-IT{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.it-IT{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.it-IT{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.it-IT{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_7SYQ47.normal{
position:relative;

}
}.it-IT{
.u_c_DR2P48.normal{
position:relative;

}
}.it-IT{
.u_c_4DR950.normal{
position:relative;

}
}.it-IT{
.u_c_3MAG52.normal{
position:relative;

}
}.it-IT{
.u_c_V45S53.normal{
position:relative;

}
}.it-IT{
.u_c_6VDD54.normal{
position:relative;

}
}.it-IT{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.it-IT{
.u_c_0P5L58.normal{
position:relative;

}
}.it-IT{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.it-IT{
.u_c_6YH561.normal{
position:relative;

}
}.it-IT{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.it-IT{
.u_c_9Z7B65.normal{
position:relative;

}
}.it-IT{
.u_c_F5DD66.normal{
position:relative;

}
}.it-IT{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.it-IT{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.it-IT{
.u_c_VRJF72.normal{
position:relative;

}
}.it-IT{
.u_c_6HXR73.normal{
position:relative;

}
}.it-IT{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.it-IT{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.it-IT{
.u_c_PR8033.normal{
position:relative;

}
}.it-IT{
.u_c_CZYQ34.normal{
position:relative;

}
}.it-IT{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.it-IT{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.it-IT{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.it-IT{
.u_c_NWC738.normal{
position:relative;

}
}.it-IT{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.it-IT{
.u_c_5CEN78.normal{
position:relative;

}
}.it-IT{
.u_c_B8SU79.normal{
position:relative;

}
}.it-IT{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.it-IT{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.it-IT{
.u_c_3XQE83.normal{
position:relative;

}
}.it-IT{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.it-IT{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.it-IT{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.it-IT{
.u_c_6QX790.normal{
position:relative;

}
}.it-IT{
.u_c_D5F091.normal{
position:relative;

}
}.it-IT{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.it-IT{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.it-IT{
.u_c_5JF295.normal{
position:relative;

}
}.it-IT{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.it-IT{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.it-IT{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_3KAF107.normal{
position:relative;

}
}.it-IT{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.it-IT{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.it-IT{
.u_c_29SD111.normal{
position:relative;

}
}.it-IT{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.it-IT{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.it-IT{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.it-IT{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.it-IT{
.u_c_B8W2120.normal{
position:relative;

}
}.it-IT{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.it-IT{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.it-IT{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.tr-TR{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.tr-TR{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.tr-TR{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.tr-TR{
.u_c_DCJ823.normal{
position:relative;

}
}.tr-TR{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_0BRZ33.normal{
position:relative;

}
}.tr-TR{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.tr-TR{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.tr-TR{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.tr-TR{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.tr-TR{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.tr-TR{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_7SYQ47.normal{
position:relative;

}
}.tr-TR{
.u_c_DR2P48.normal{
position:relative;

}
}.tr-TR{
.u_c_4DR950.normal{
position:relative;

}
}.tr-TR{
.u_c_3MAG52.normal{
position:relative;

}
}.tr-TR{
.u_c_V45S53.normal{
position:relative;

}
}.tr-TR{
.u_c_6VDD54.normal{
position:relative;

}
}.tr-TR{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.tr-TR{
.u_c_0P5L58.normal{
position:relative;

}
}.tr-TR{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.tr-TR{
.u_c_6YH561.normal{
position:relative;

}
}.tr-TR{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.tr-TR{
.u_c_9Z7B65.normal{
position:relative;

}
}.tr-TR{
.u_c_F5DD66.normal{
position:relative;

}
}.tr-TR{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.tr-TR{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.tr-TR{
.u_c_VRJF72.normal{
position:relative;

}
}.tr-TR{
.u_c_6HXR73.normal{
position:relative;

}
}.tr-TR{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.tr-TR{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.tr-TR{
.u_c_PR8033.normal{
position:relative;

}
}.tr-TR{
.u_c_CZYQ34.normal{
position:relative;

}
}.tr-TR{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.tr-TR{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.tr-TR{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.tr-TR{
.u_c_NWC738.normal{
position:relative;

}
}.tr-TR{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.tr-TR{
.u_c_5CEN78.normal{
position:relative;

}
}.tr-TR{
.u_c_B8SU79.normal{
position:relative;

}
}.tr-TR{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.tr-TR{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.tr-TR{
.u_c_3XQE83.normal{
position:relative;

}
}.tr-TR{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.tr-TR{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.tr-TR{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.tr-TR{
.u_c_6QX790.normal{
position:relative;

}
}.tr-TR{
.u_c_D5F091.normal{
position:relative;

}
}.tr-TR{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.tr-TR{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.tr-TR{
.u_c_5JF295.normal{
position:relative;

}
}.tr-TR{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.tr-TR{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.tr-TR{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_3KAF107.normal{
position:relative;

}
}.tr-TR{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.tr-TR{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.tr-TR{
.u_c_29SD111.normal{
position:relative;

}
}.tr-TR{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.tr-TR{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.tr-TR{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.tr-TR{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.tr-TR{
.u_c_B8W2120.normal{
position:relative;

}
}.tr-TR{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.tr-TR{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.tr-TR{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.pl-PL{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.pl-PL{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.pl-PL{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.pl-PL{
.u_c_DCJ823.normal{
position:relative;

}
}.pl-PL{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_0BRZ33.normal{
position:relative;

}
}.pl-PL{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pl-PL{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.pl-PL{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.pl-PL{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.pl-PL{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.pl-PL{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_7SYQ47.normal{
position:relative;

}
}.pl-PL{
.u_c_DR2P48.normal{
position:relative;

}
}.pl-PL{
.u_c_4DR950.normal{
position:relative;

}
}.pl-PL{
.u_c_3MAG52.normal{
position:relative;

}
}.pl-PL{
.u_c_V45S53.normal{
position:relative;

}
}.pl-PL{
.u_c_6VDD54.normal{
position:relative;

}
}.pl-PL{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.pl-PL{
.u_c_0P5L58.normal{
position:relative;

}
}.pl-PL{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.pl-PL{
.u_c_6YH561.normal{
position:relative;

}
}.pl-PL{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.pl-PL{
.u_c_9Z7B65.normal{
position:relative;

}
}.pl-PL{
.u_c_F5DD66.normal{
position:relative;

}
}.pl-PL{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pl-PL{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.pl-PL{
.u_c_VRJF72.normal{
position:relative;

}
}.pl-PL{
.u_c_6HXR73.normal{
position:relative;

}
}.pl-PL{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.pl-PL{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pl-PL{
.u_c_PR8033.normal{
position:relative;

}
}.pl-PL{
.u_c_CZYQ34.normal{
position:relative;

}
}.pl-PL{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.pl-PL{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.pl-PL{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pl-PL{
.u_c_NWC738.normal{
position:relative;

}
}.pl-PL{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.pl-PL{
.u_c_5CEN78.normal{
position:relative;

}
}.pl-PL{
.u_c_B8SU79.normal{
position:relative;

}
}.pl-PL{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.pl-PL{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.pl-PL{
.u_c_3XQE83.normal{
position:relative;

}
}.pl-PL{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pl-PL{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.pl-PL{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.pl-PL{
.u_c_6QX790.normal{
position:relative;

}
}.pl-PL{
.u_c_D5F091.normal{
position:relative;

}
}.pl-PL{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.pl-PL{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.pl-PL{
.u_c_5JF295.normal{
position:relative;

}
}.pl-PL{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pl-PL{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.pl-PL{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_3KAF107.normal{
position:relative;

}
}.pl-PL{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.pl-PL{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.pl-PL{
.u_c_29SD111.normal{
position:relative;

}
}.pl-PL{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.pl-PL{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.pl-PL{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.pl-PL{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pl-PL{
.u_c_B8W2120.normal{
position:relative;

}
}.pl-PL{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pl-PL{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.pl-PL{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.id-ID{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.id-ID{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.id-ID{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.id-ID{
.u_c_DCJ823.normal{
position:relative;

}
}.id-ID{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_0BRZ33.normal{
position:relative;

}
}.id-ID{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.id-ID{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.id-ID{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.id-ID{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.id-ID{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.id-ID{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_7SYQ47.normal{
position:relative;

}
}.id-ID{
.u_c_DR2P48.normal{
position:relative;

}
}.id-ID{
.u_c_4DR950.normal{
position:relative;

}
}.id-ID{
.u_c_3MAG52.normal{
position:relative;

}
}.id-ID{
.u_c_V45S53.normal{
position:relative;

}
}.id-ID{
.u_c_6VDD54.normal{
position:relative;

}
}.id-ID{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.id-ID{
.u_c_0P5L58.normal{
position:relative;

}
}.id-ID{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.id-ID{
.u_c_6YH561.normal{
position:relative;

}
}.id-ID{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.id-ID{
.u_c_9Z7B65.normal{
position:relative;

}
}.id-ID{
.u_c_F5DD66.normal{
position:relative;

}
}.id-ID{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.id-ID{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.id-ID{
.u_c_VRJF72.normal{
position:relative;

}
}.id-ID{
.u_c_6HXR73.normal{
position:relative;

}
}.id-ID{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.id-ID{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.id-ID{
.u_c_PR8033.normal{
position:relative;

}
}.id-ID{
.u_c_CZYQ34.normal{
position:relative;

}
}.id-ID{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.id-ID{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.id-ID{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.id-ID{
.u_c_NWC738.normal{
position:relative;

}
}.id-ID{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.id-ID{
.u_c_5CEN78.normal{
position:relative;

}
}.id-ID{
.u_c_B8SU79.normal{
position:relative;

}
}.id-ID{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.id-ID{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.id-ID{
.u_c_3XQE83.normal{
position:relative;

}
}.id-ID{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.id-ID{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.id-ID{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.id-ID{
.u_c_6QX790.normal{
position:relative;

}
}.id-ID{
.u_c_D5F091.normal{
position:relative;

}
}.id-ID{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.id-ID{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.id-ID{
.u_c_5JF295.normal{
position:relative;

}
}.id-ID{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.id-ID{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.id-ID{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_3KAF107.normal{
position:relative;

}
}.id-ID{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.id-ID{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.id-ID{
.u_c_29SD111.normal{
position:relative;

}
}.id-ID{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.id-ID{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.id-ID{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.id-ID{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.id-ID{
.u_c_B8W2120.normal{
position:relative;

}
}.id-ID{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.id-ID{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.id-ID{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.ar-SA{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:36.46vw;
height:26.67vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144443-4.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144368-49.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:36.46vw;
height:38.33vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144280-74.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:10.94vw;
height:3.23vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732012144073-47.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#51b5c2;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#3c78b9;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.ar-SA{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.ar-SA{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.ar-SA{
.u_c_DCJ823.normal{
position:relative;

}
}.ar-SA{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_0BRZ33.normal{
position:relative;

}
}.ar-SA{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ar-SA{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.ar-SA{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.ar-SA{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.ar-SA{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.ar-SA{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_7SYQ47.normal{
position:relative;

}
}.ar-SA{
.u_c_DR2P48.normal{
position:relative;

}
}.ar-SA{
.u_c_4DR950.normal{
position:relative;

}
}.ar-SA{
.u_c_3MAG52.normal{
position:relative;

}
}.ar-SA{
.u_c_V45S53.normal{
position:relative;

}
}.ar-SA{
.u_c_6VDD54.normal{
position:relative;

}
}.ar-SA{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.ar-SA{
.u_c_0P5L58.normal{
position:relative;

}
}.ar-SA{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.ar-SA{
.u_c_6YH561.normal{
position:relative;

}
}.ar-SA{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.ar-SA{
.u_c_9Z7B65.normal{
position:relative;

}
}.ar-SA{
.u_c_F5DD66.normal{
position:relative;

}
}.ar-SA{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ar-SA{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ar-SA{
.u_c_VRJF72.normal{
position:relative;

}
}.ar-SA{
.u_c_6HXR73.normal{
position:relative;

}
}.ar-SA{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:2.34vw;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.20vw;
white-space:pre-line;

}
}.ar-SA{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ar-SA{
.u_c_PR8033.normal{
position:relative;

}
}.ar-SA{
.u_c_CZYQ34.normal{
position:relative;

}
}.ar-SA{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.ar-SA{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.ar-SA{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ar-SA{
.u_c_NWC738.normal{
position:relative;

}
}.ar-SA{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ar-SA{
.u_c_5CEN78.normal{
position:relative;

}
}.ar-SA{
.u_c_B8SU79.normal{
position:relative;

}
}.ar-SA{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.ar-SA{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ar-SA{
.u_c_3XQE83.normal{
position:relative;

}
}.ar-SA{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ar-SA{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.ar-SA{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.ar-SA{
.u_c_6QX790.normal{
position:relative;

}
}.ar-SA{
.u_c_D5F091.normal{
position:relative;

}
}.ar-SA{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.ar-SA{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ar-SA{
.u_c_5JF295.normal{
position:relative;

}
}.ar-SA{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ar-SA{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.ar-SA{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_3KAF107.normal{
position:relative;

}
}.ar-SA{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.ar-SA{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.ar-SA{
.u_c_29SD111.normal{
position:relative;

}
}.ar-SA{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.ar-SA{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.ar-SA{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.ar-SA{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ar-SA{
.u_c_B8W2120.normal{
position:relative;

}
}.ar-SA{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ar-SA{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.ar-SA{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}
</style>
